import React from "react";
import cx from "classnames";
import { colors } from "../Theme";
import ButtonIconV2 from "../ButtonIconV2";
import { CloseLine } from "../IconV2/react";
import Text, { H4 } from "../Text";
import { css } from "@linaria/core";

export type ModalHeaderProps = React.PropsWithChildren<{
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  closable?: boolean;
  onRequestClose?: () => void;
  className?: string;
}>;

const ModalHeader = ({
  title,
  subtitle,
  children,
  closable = true,
  onRequestClose,
  className,
}: ModalHeaderProps) => (
  <header className={cx(modalHeader, className)}>
    {title !== undefined && <H4 className="title">{title}</H4>}
    {closable && (
      <ButtonIconV2 onClick={onRequestClose} tabIndex={-1} className="close-button">
        <CloseLine size="l" color={colors.titanium800} />
      </ButtonIconV2>
    )}
    {subtitle !== undefined && typeof subtitle === "string" && (
      <Text className="subtitle" type="body1">
        {subtitle}
      </Text>
    )}
    {children}
  </header>
);

export default ModalHeader;

const modalHeader = css`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px;
  align-items: center;

  & > .title {
    color: ${colors.carbon900};
    overflow-wrap: break-word;
    hyphens: auto;
    width: 100%;
  }

  & > .subtitle {
    color: ${colors.carbon700};
    grid-column: 1 / -1;
    grid-row: 2;
  }

  & > .close-button {
    align-self: start;
    height: 20px;
    width: 20px;
    grid-row: 1 / span 2;
    grid-column: 2 / -1;
  }
`;
